import { useQuery } from 'react-query';

import { getSTMonitoring } from 'api/reports/getSTMonitoring';
import { TrapTypeMonitoring } from 'api/reports/types';

export const useGetSTMonitoring = (
  slug: string,
  trapType: TrapTypeMonitoring,
  start_date: string,
  end_date: string,
  filter_type?: string,
  enabled: boolean = true,
) => {
  const { data, refetch, isRefetching, isLoading } = useQuery(
    ['stMonitoring', slug, trapType],
    () => getSTMonitoring(slug, trapType, start_date, end_date, filter_type || 'default'),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );

  return { data, refetch, isRefetching, isLoading };
};

export default useGetSTMonitoring;
